import { StyledLink } from './styles/link';

export const Link = ({children, ...rest}) => {
    return <StyledLink {...rest}>{children}</StyledLink>
};
